export default {
    url: '/finished',
    // TODO ::  COUR-1281 - use this template to move on
    template: '<quiz-finished form-submission="vm.formSubmission"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            // TODO :: consider reducing shown fields, all fields should not be seen by another person
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form,trainingActiveI18n,occurrenceTraining,trainingProgress,formSubmissionAnswers.question' }).$promise;
        }
    },
    controller (formSubmission) {
        this.formSubmission = formSubmission;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/quiz/finished/index.js